import React, { useState, useCallback } from 'react';
import { Input, Button } from 'antd';
import s from './s.module.less';
import klarityLogo from 'assets/logo/KlarityLogo.png';
import noProvidersImg from 'assets/groupPractice/noProviders.png';

type Props = {
    onSearch: (url: string) => void | Promise<void>;
    onExit: () => void;
    onAddManually: () => void;
};

const NoProvidersFoundPage: React.FC<Props> = ({ onSearch, onExit, onAddManually }) => {
    const [url, setUrl] = useState('');
    const [searching, setSearching] = useState(false);

    const handleSearch = useCallback(async () => {
        if (!url.trim() || searching) return;
        setSearching(true);
        try {
            await onSearch(url.trim());
            setUrl('');
        } finally {
            setSearching(false);
        }
    }, [url, searching, onSearch]);

    return (
        <div className={s.page}>
            <div className={s.topBar}>
                <img src={klarityLogo} alt="Klarity" className={s.logo} />
                <Button className={s.exitBtn} onClick={onExit}>
                    Exit
                </Button>
            </div>

            <div className={s.content}>
                <img src={noProvidersImg} alt="No providers found" style={{ width: '240px' }} />

                <div className={s.textBlock}>
                    <h2 className={s.title}>No providers found</h2>
                    <div className={s.desc}>
                        <p>{`We couldn't find any provider profiles on your practice website.`}</p>
                        <p>{`Try entering a page that lists your providers (for example, an "Our Team" page), or add providers manually.`}</p>
                    </div>
                </div>

                <div className={s.searchRow}>
                    <Input
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://www.yourpractice.com"
                        className={s.urlInput}
                        onPressEnter={handleSearch}
                    />
                    <Button
                        type="primary"
                        className={s.searchBtn}
                        onClick={handleSearch}
                        disabled={!url.trim()}
                        loading={searching}
                    >
                        Search
                    </Button>
                </div>

                <span className={s.manualLink} onClick={onAddManually}>
                    Add provider manually
                </span>
            </div>
        </div>
    );
};

export default NoProvidersFoundPage;
